<template>


    <Header v-if="ShowHeaderFooter" :NavLinks="NavLinks" @openSignUpdmodel="openSignUpdmodel"
            @goToPortal="goToPortal"
            @openLoginPage="openLoginPage" :hidden="$route.name == 'GolfCart Rental Confirmation' && isBookingFromMaya == 'Yes' && isInIFrame == true"
            @logout="logout" :isUserLoggedIn="isUserLoggedIn" ref="headerElement" :name="name" :ProfilePic="ProfilePic"
            :OurAddress="OurAddress" :OurEmail="OurEmail" :OurPhone="OurPhone"></Header>

    <div class="page-body-wrapper" @click="CloseHeader">
        <ChatBoatBox v-if="$route.name !='GolfCart Rental Confirmation' && (envType == 'Stage' || envType =='localDev') && $route.name != 'Login' && $route.name != 'SignupPage' "></ChatBoatBox>
        <div class="page-body">
            <router-view :AssetComapreArray="AssetComapreArray" />
        </div>
        <div class="tab-pane fade login-form-tab show active" id="login-form-tab" role="tabpanel">
            <div id="hz-login-messages" class="hz-social-messages"></div>
        </div>
    </div>
    <!--<div style="height: 100vh;">
        <iframe src="/chatbotfront.html" width="100%" height="100%" frameborder="0"></iframe>
    </div>-->
    <Footer v-if="ShowHeaderFooter" id="footer-bottom"
            :footerNavLinks="footerNavLinks" :serviceLinks="serviceLinks" :FooterLogoDescription="FooterLogoDescription" :secondaryLogoLink="secondaryLogoLink"
            :OurAddress="OurAddress" :OurEmail="OurEmail" :OurPhone="OurPhone" :Copyrights="Copyrights" :hidden="isInIFrame == true && $route.name == 'GolfCart Rental Confirmation' && isBookingFromMaya == 'Yes'">
    </Footer>
    <!--<signUpComponent v-if="isopenSignUpModal" @cancelClicked="closeSignUpdmodel"></signUpComponent>-->
    <!--<loginComponent v-if="loginmodelopen" :AfterLoginRoute="AfterLoginRoute" @cancelmodel="CloseLoginModal"></loginComponent>-->
    <AssetComparePopupComponent v-if="isComparePopUpOpen" :AssetComapreArray="AssetComapreArray" @ShowAssetComparePopup="ShowAssetComparePopup" @CloseComparePopup="CloseComparePopup" @RemoveCompareImage="RemoveCompareImage"></AssetComparePopupComponent>
    <div :class="{'modal-backdrop fade' : themeName !== 'GolfCart'}" :id="{'isvisbleModalFade' : themeName !== 'GolfCart'}"></div>
    <subscribeNewsletter v-if="showsubscribenewsletter || isPopUpShown =='true'" @closenewslettermodel="closenewslettermodel" @permanentclose="permanentclose"></subscribeNewsletter>
    <Loading v-model:active="isLoading"></Loading>

    <a href="#" :class="{'back-to-top d-flex align-items-center justify-content-center':true,'active':isscrolled}"><i class="houzez-icon icon-arrow-up-1 text-white"></i></a>
</template>

<script>
    import { createConfirmDialog } from "vuejs-confirm-dialog";
    import SimpleDialog from "../views/shared/SimpleDialog.vue";
    import AssetComparePopupComponent from '@/views/ManageAsset/assetComparePopup.vue';
    import AuthUserServices from '../Services/AuthUserServices.js';
    import UserService from '@/Services/frontEndService.js';
    
    export default {
        name: 'layoutName',
        beforeCreate: function () {
            this.themeName = localStorage.getItem('theme');
            if (this.themeName == 'Dark') {
                this.$options.components.Header = require('@/layout/Themes/DarkTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/DarkTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/DarkTheme/CSS/style.css')
                require('@/assets/Theme/DarkTheme/CSS/animate.min.css')
                require('@/assets/Theme/DarkTheme/CSS/flaticon.css')
                document.body.classList.add('dark-version');

            }
            else if (this.themeName == 'Clean') {
                this.$options.components.Header = require('@/layout/Themes/CleanTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/CleanTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/CleanTheme/CSS/style.css')
                require('@/assets/Theme/CleanTheme/JS/custom.js')
            }
            else if (this.themeName == 'PropertyRentalV2') {
                this.$options.components.Header = require('@/layout/Themes/PropertyRentalV2/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/PropertyRentalV2/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/PropertyRentalV2/CSS/style.css')
                require('@/assets/Theme/PropertyRentalV2/JS/custom.js')
            }
            else if (this.themeName == 'ExperienceTheme') {
                this.$options.components.Header = require('@/layout/Themes/ExperienceTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/ExperienceTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/ExperienceTheme/CSS/style.css')
                require('@/assets/Theme/ExperienceTheme/CSS/Experience.css')
                require('@/assets/Theme/ExperienceTheme/JS/custom.js')
            }
            else if (this.themeName == 'Modern') {
                this.$options.components.Header = require('@/layout/Themes/ModernTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/ModernTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/ModernTheme/CSS/style.css')
                require('@/assets/Theme/ModernTheme/CSS/font-icons.css')
            }
            else if (this.themeName == 'Classic') {
                this.$options.components.Header = require('@/layout/Themes/ClassicTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/ClassicTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/ClassicTheme/CSS/style.css')
                require('@/assets/Theme/ClassicTheme/CSS/animate.min.css')
            }
            else if (this.themeName == 'SingleHotel') {
                this.$options.components.Header = require('@/layout/Themes/SingleHotel/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/SingleHotel/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/SingleHotel/CSS/style.css')
                require('@/assets/Theme/SingleHotel/CSS/animate.min.css')
            }
            else if (this.themeName == 'SpaServices') {
                this.$options.components.Header = require('@/layout/Themes/SpaServices/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/SpaServices/Components/footervue/Footer.vue').default;
                this.$options.components.ChatBoatBox = require('@/layout/Themes/SpaServices/Components/Home/Maya_SpaService.vue').default;
                require('@/assets/Theme/SpaServices/CSS/style.css')
                require('@/assets/Theme/SpaServices/CSS/animate.min.css')
            }
            else if (this.themeName == 'Restaurant') {
                this.$options.components.Header = require('@/layout/Themes/Restaurant/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/Restaurant/Components/footervue/Footer.vue').default;
                this.$options.components.ChatBoatBox = require('@/layout/Themes/Restaurant/Components/Home/Maya_Restaurant.vue').default;
                require('@/assets/Theme/Restaurant/CSS/style.css')
                require('@/assets/Theme/Restaurant/CSS/animate.min.css')
            }
            else if (this.themeName == 'GolfCart') {
                this.$options.components.Header = require('@/layout/Themes/GolfCart/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/GolfCart/Components/footervue/Footer.vue').default;
                this.$options.components.ChatBoatBox = require('@/layout/Themes/GolfCart/Components/Home/plain_html.vue').default;
                //require('@/assets/Theme/GolfCart/css/bootstrap-datetimepicker.min.css')
                //require('@/assets/Theme/GolfCart/css/feather.css')
                //require('@/assets/Theme/GolfCart/css/owl.carousel.min.css')
                localStorage.setItem('isSubscribePopupShown', 'false');
                this.showsubscribenewsletter = false;

                require('@/assets/Theme/GolfCart/plugins/fontawesome/css/fontawesome.min.css');
                require('@/assets/Theme/GolfCart/plugins/fontawesome/css/all.min.css');
                require('@/assets/Theme/GolfCart/plugins/select2/css/select2.min.css');
                require('@/assets/Theme/GolfCart/css/bootstrap-datetimepicker.min.css');
                require('@/assets/Theme/GolfCart/plugins/aos/aos.css');
                require('@/assets/Theme/GolfCart/css/feather.css');
                require('@/assets/Theme/GolfCart/css/owl.carousel.min.css');
                require('@/assets/Theme/GolfCart/plugins/boxicons/css/boxicons.min.css');
                 require('@/assets/Theme/GolfCart/css/style.css');;


                require("@/assets/Theme/GolfCart/js/jquery-3.7.1.min.js");
                require("@/assets/Theme/GolfCart/js/bootstrap.bundle.min.js");
                require("@/assets/Theme/GolfCart/js/jquery.waypoints.js");
                require("@/assets/Theme/GolfCart/js/jquery.counterup.min.js");
                require("@/assets/Theme/GolfCart/plugins/select2/js/select2.min.js");
                require("@/assets/Theme/GolfCart/plugins/aos/aos.js");
                require("@/assets/Theme/GolfCart/js/backToTop.js");
                
                
                require("@/assets/Theme/GolfCart/plugins/moment/moment.min.js");
                require("@/assets/Theme/GolfCart/js/bootstrap-datetimepicker.min.js"); 
                require("@/assets/Theme/GolfCart/js/owl.carousel.min.js");
                require("@/assets/Theme/GolfCart/js/script.js");

            }
            else {
                this.$options.components.Header = require('@/layout/Themes/DefaultTheme/Components/headervue/Header.vue').default;
                this.$options.components.Footer = require('@/layout/Themes/DefaultTheme/Components/footervue/Footer.vue').default;
                require('@/assets/Theme/DefaultTheme/CSS/style.css')

            }
            this.$options.components.loginComponent = require('@/views/LoginCompany/logincompany.vue').default;
            this.$options.components.signUpComponent = require('@/views/SignUp/signUp.vue').default;
            this.$options.components.subscribeNewsletter = require('@/views/SubscribeNewsletter/subscribeNewsletter.vue').default;

        },
        components: {
            
            Header: () => {
                if (this.themeName == 'Dark') {
                    import('@/layout/Themes/DarkTheme/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'Clean') {
                    import('@/layout/Themes/CleanTheme/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'PropertyRentalV2') {
                    import('@/layout/Themes/PropertyRentalV2/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'ExperienceTheme') {
                    import('@/layout/Themes/ExperienceTheme/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'Modern') {
                    import('@/layout/Themes/ModernTheme/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'Classic') {
                    import('@/layout/Themes/ClassicTheme/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'SingleHotel') {
                    import('@/layout/Themes/SingleHotel/Components/headervue/Header.vue');
                }
                else if (this.themeName == 'Restaurant') {
                    import('@/layout/Themes/Restaurant/Components/headervue/Header.vue');
                    import('@/layout/Themes/Restaurant/Components/Home/Maya_Restaurant.vue');
                }
                else if (this.themeName == 'Restaurant') {
                    import('@/layout/Themes/Restaurant/Components/headervue/Header.vue');
                    import('@/layout/Themes/Restaurant/Components/Home/Maya_Restaurant.vue');
                }
                else if (this.themeName == 'SpaServices') {
                    import('@/layout/Themes/SpaServices/Components/headervue/Header.vue');
                    import('@/layout/Themes/SpaServices/Components/Home/Maya_SpaService.vue');
                }
                else if (this.themeName == 'GolfCart') {
                    import('@/layout/Themes/GolfCart/Components/Home/plain_html.vue')
                    import('@/layout/Themes/GolfCart/Components/headervue/Header.vue');
                }
                else {
                    import('@/layout/Themes/DefaultTheme/Components/headervue/Header.vue');
                }

            },
            Footer: () => {
                if (this.themeName == 'Dark') {
                    import('@/layout/Themes/DarkTheme/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'Clean') {
                    import('@/layout/Themes/CleanTheme/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'PropertyRentalV2') {
                    import('@/layout/Themes/PropertyRentalV2/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'ExperienceTheme') {
                    import('@/layout/Themes/ExperienceTheme/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'Modern') {
                    import('@/layout/Themes/ModernTheme/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'Classic') {
                    import('@/layout/Themes/ClassicTheme/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'SingleHotel') {
                    import('@/layout/Themes/SingleHotel/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'Restaurant') {
                    import('@/layout/Themes/Restaurant/Components/footervue/Footer.vue');
                }
                else if (this.themeName == 'SpaServices') {
                    import('@/layout/Themes/SpaServices/Components/Home/Maya_SpaService.vue');
                    import('@/layout/Themes/SpaServices/Components/footervue/Footer.vue');
                }
                else {
                    import('@/layout/Themes/DefaultTheme/Components/footervue/Footer.vue');
                }
            },
            signUpComponent: () => {
                import('@/views/SignUp/signUp.vue');
            },
            loginComponent: () => {
                import('@/views/LoginCompany/logincompany.vue');
            },
            subscribeNewsletter: () => {
                import('@/views/SubscribeNewsletter/subscribeNewsletter.vue');
            },

            AssetComparePopupComponent



        },
        data() {
            let themeName = localStorage.getItem('theme');
            let NavLinks; let footerNavLinks;
            if (this.$router.options.HeaderNavlinks != null && this.$router.options.HeaderNavlinks != "") {
                NavLinks = JSON.parse(this.$router.options.HeaderNavlinks);
            }
            else {
                NavLinks = JSON.parse(localStorage.getItem("HeaderNavlinks"));
            }
            if (this.$router.options.HeaderNavlinks != null && this.$router.options.HeaderNavlinks != "") {
                footerNavLinks = JSON.parse(this.$router.options.FooterNavlinks);
            }
            else {
                footerNavLinks = JSON.parse(localStorage.getItem("FooterNavlinks"));

            }

            const FooterLogoDescription = 'Our property management software streamlines the entire occupancy process to save you time and money.';
            const CurrentYear = new Date().getFullYear();
            const Copyrights = `${this.$t('StoreFront.Copyright')} &copy;  ${CurrentYear} - ${localStorage.getItem('companyName')}. ${this.$t('StoreFront.AllRightsReserved')}.`
            let isPopUpShown = localStorage.getItem('isSubscribePopupShown');
            return {
                themeName,
                NavLinks,
                footerNavLinks,
                FooterLogoDescription,
                OurAddress: '',
                OurEmail: '',
                OurPhone: '',
                Copyrights,
                isopenSignUpModal: false,
                loginmodelopen: false,
                isUserLoggedIn: false,
                isLoading: true,
                isCloseComparePopup: false,
                AfterLoginRoute: 'Home',
                isComparePopUpOpen: false,
                comparePopupiewDetail: null,
                AssetComapreArray: [],
                isscrolled: false,
                scrollPosition: 0,
                showsubscribenewsletter: false,
                timeinterval: 15000,
                ShowHeaderFooter: true,
                isPopUpShown,
                name,
                ProfilePic: null,
                secondaryLogoLink: null,
                envType: null,
                isBookingFromMaya: '',
                isInIFrame: false
            }
        },

        created() {
            if (window.self !== window.top) {
                this.isInIFrame = true;
               
                
            }
            this.envType = process.env.VUE_APP_Invironment_Mode;
            this.isBookingFromMaya = '';
            if (localStorage.getItem('isBookingFromMaya')) {
                this.isBookingFromMaya = localStorage.getItem('isBookingFromMaya');
                localStorage.removeItem('isBookingFromMaya');
            }
            localStorage.removeItem("CurrentCompDomain");
            if (this.themeName =='GolfCart') {
                this.showsubscribenewsletter = false;
                this.isPopUpShown = 'false';
            }
            this.isLoading = true;
            this.GetAddressDetailOfCompany();
            this.isUserLoggedIn = (localStorage.getItem('access_token')) ? true : false;

            setTimeout(() => { this.isLoading = false }, 1000);
            debugger;
            if (this.isPopUpShown == false) {
                localStorage.setItem('isSubscribePopupShown', 'true');

            }
            let commpanyUrl = localStorage.getItem('companyURL');
            let found = this.$route.fullPath.includes(commpanyUrl + '/dashboard');
            this.name = JSON.parse(localStorage.getItem('userinfo'));
            if (this.$filters.IsNull(this.name, true, null) != null) {
                this.ProfilePic = (this.$filters.IsNull(this.name.profilePic, true, null) == null) ? require('../assets/images/default.png') : this.name.profilePic;
            }
            this.ShowHeaderFooter = (found) ? false : true;
            this.GetDynamicContent();
        },
        mounted() {
            window.addEventListener('scroll', this.updateScroll);
            let companyID = localStorage.getItem('companyId')
            let companyName = localStorage.getItem('companyName')
            if (companyID == 'e42a359a-d517-483c-8d7d-5353ca886b41' || companyID == 'E42A359A-D517-483C-8D7D-5353CA886B41') {
                this.setTimerForSubsribePopUp();
            }

        },
        //watch: {
        //    $route(to, from) {
        //        let commpanyUrl = localStorage.getItem('companyURL');
        //        let found = to.fullPath.includes(commpanyUrl +'/dashboard');
        //        this.ShowHeaderFooter = (found)? false:true;

        //    }
        //},
        updated() {
            var CurrnetUserLoggedIn = (localStorage.getItem('access_token')) ? true : false;
            if (this.isUserLoggedIn != CurrnetUserLoggedIn) {
                this.isUserLoggedIn = CurrnetUserLoggedIn;
                this.name = JSON.parse(localStorage.getItem('userinfo'));
                if (this.$filters.IsNull(this.name, true, null) != null) {

                    this.ProfilePic = (this.$filters.IsNull(this.name.profilePic, true, null) == null) ? require('../assets/images/default.png') : this.name.profilePic;
                }
            }
            this.isPopUpShown = localStorage.getItem('isSubscribePopupShown');

        },
        methods: {
            goToPortal() {
                let UserName = JSON.parse(localStorage.getItem('userinfo')).userName
                let encryptedUserName = this.$helpers.EncryptUserName(UserName, this);
                let url = `${this.$custConfig.adminPortalUrl}loginCompanyUser/${encryptedUserName}/${location.host}/${localStorage.getItem('companyURL')}`;

                window.open(url, '_blank');
                //window.location.assign(`${this.$custConfig.adminPortalUrl}loginCompanyUser/${encryptedUserName}/${location.host}/${localStorage.getItem('companyURL')}`)
            },
            setTimerForSubsribePopUp() {
                //let cookie = document.cookie;
                if (!this.isUserLoggedIn) {
                    setTimeout(() => {
                        this.showsubscribenewsletter = true;
                        this.$helpers.enbalePopUpCss();
                    }, this.timeinterval)

                }

            },
            closenewslettermodel() {
                this.showsubscribenewsletter = false;
                this.timeinterval = 300000
                this.setTimerForSubsribePopUp();
                this.$helpers.disablePopUpCss();
                localStorage.setItem('isSubscribePopupShown', 'false');
            },
            permanentclose() {
                this.showsubscribenewsletter = false;
                this.$helpers.disablePopUpCss();
            },
            updateScroll() {
                this.scrollPosition = window.scrollY;
                // alert(this.scrollPosition)
                if (this.scrollPosition != 0) {
                    this.isscrolled = true;
                    setTimeout(() => {
                        if (this.scrollPosition != 0)
                            $("#headersticky").addClass("header-sticky")
                    }, 1000);

                }
                else {
                    this.isscrolled = false;
                    $("#headersticky").removeClass("header-sticky");
                }
            },
            async logout() {
                debugger
                const IPAddress = await UserService.GetIPAddress();
                const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                    question: this.$t('StoreFront.LogoutMessage'),
                    header: this.$t('StoreFront.Logout'),
                    cancel: this.$t('StoreFront.Cancel'),
                    confirm: this.$t('StoreFront.Ok'),
                });
                onConfirm(() => {
                    this.isLoading = true;
                    UserService.LogoutHistory(localStorage.getItem('userId'), IPAddress).then(res => {
                    })
                    localStorage.removeItem("userId");
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("CheckInCheckoutDate");
                    localStorage.removeItem("CheckAvailablityGuest");
                    localStorage.removeItem("domain");
                    localStorage.removeItem("userinfo");
                    localStorage.removeItem('cartData');
                    if (localStorage.getItem('theme') == 'GolfCart') {
                        this.$router.push({ name: 'Login' })
                    }
                    else {
                        this.$router.push({ name: `HomePage` });
                    }
                   
                    //this.$router.go(0);
                    this.isUserLoggedIn = false;
                    setTimeout(() => { this.isLoading = false }, 2500);
                });
                reveal(() => {

                });
            },
            GetAddressDetailOfCompany() {
                try {
                    let companyAddress = JSON.parse(this.$filters.IsNull(localStorage.getItem('companyAddress'), true, null));
                    this.OurEmail = this.$filters.IsNull(companyAddress.email, true, ' - ');
                    this.OurPhone = this.$filters.IsNull(companyAddress.phone, true, ' - ');
                    this.OurAddress = this.$filters.IsNull(companyAddress.Address1, ' ') + ' ' + this.$filters.IsNull(companyAddress.Address2, ' ') + ', ' + this.$filters.IsNull(companyAddress.city, ' ') + ', ' + this.$filters.IsNull(companyAddress.state, ' ') + ', ' + this.$filters.IsNull(companyAddress.zip, ' ') + ', ' + this.$filters.IsNull(companyAddress.country, ' ');
                }
                catch (error) {
                    this.OurAddress = '';
                    this.OurEmail = '';
                    this.OurPhone = '';
                }
            },
            //openSignUpdmodel() {
            //    this.isLoading = true;
            //    this.isopenSignUpModal = true;
            //    this.$helpers.enbalePopUpCss();
            //    setTimeout(() => {
            //        this.isLoading = false;
            //    }, 1000);
            //},
            //closeSignUpdmodel() {
            //    this.isopenSignUpModal = false;
            //    this.$helpers.disablePopUpCss();
            //},
            OpenLoginModal(AfterLoginRoute = 'Home') {
                //this.AfterLoginRoute = AfterLoginRoute;
                //this.isLoading = true;
                //this.loginmodelopen = true;
                //this.$helpers.enbalePopUpCss();
                //setTimeout(() => { this.isLoading = false }, 1000);
            },
            //CloseLoginModal() {
            //    this.loginmodelopen = false;
            //    this.$helpers.disablePopUpCss();
            //},
            openLoginPage() {
                this.$router.push({ name: `Login` });
            },
            switchToAssetComapredetail(id) {
                this.$router.push({ path: `assetCompareDetails/${id}` });
            },
            CloseComparePopup() {
                this.AssetComapreArray = [];
                this.isComparePopUpOpen = false;
                this.$helpers.disablePopUpCss();
            },
            ShowAssetComparePopup(newassetValue) {
                let foundIndex = this.AssetComapreArray.findIndex(item => {
                    return item.id == newassetValue.id
                })

                //  Asset found
                if (foundIndex != -1) {
                    this.AssetComapreArray.splice(foundIndex, 1);
                }
                else {
                    if (this.AssetComapreArray.length < 4) {
                        this.AssetComapreArray.push(newassetValue);
                    }
                    else {
                        this.error(this.$t('StoreFront.Youitem'));
                    }
                }
                this.$helpers.enbaleComparePopUpCss();
                this.isComparePopUpOpen = true;
            },
            CloseHeader() {
                try {
                    this.$refs.headerElement.CloseLeftMenu();
                    this.$refs.headerElement.CloseMenutoggle();
                }
                catch (error) {

                }
            },
            GetDynamicContent() {
                AuthUserServices.GetDynamicContentForComapny(localStorage.getItem("companyId"), localStorage.getItem("userId"), localStorage.getItem("LanguageId")).then(res => {
                    this.secondaryLogoLink = res.data.primaryLogoLink
                    this.FooterLogoDescription = res.data.footerContent
                    console.log('Footer', this.FooterLogoDescription);
                    console.log('Footerdat', res.data);
                })
            },
        },
    }
</script>
